import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { strings, getCurrentLocale } from '../../../localization';
import { accountHasBilling } from '../../common/billing';

const hasCCInfo = (billingInfo) => {
    if (!billingInfo || !billingInfo.year) return false;
    return true;
}

export default class NoRavensError extends Component {

    render() {

        const { accountDetails } = this.props;
        if(!accountHasBilling(accountDetails)) {
            // Channel MVP or other non-billing account type
            // Don't check for CC
            return (
                <div className="page-error">
                    <h2>{strings.no_ravens_please_connect_your_ravens}</h2>
                    <hr />
                    <p>{strings.no_ravens_your_ravens_are_not_currently_detected}</p>
                    <p>{strings.no_ravens_your_ravens_are_not_currently_detected_instructions}</p>
                </div>
            );
        }
        else if(accountDetails && accountDetails.accountType === "FLEET") {
            if(hasCCInfo(accountDetails.billingInfo)) {
                return (
                    <div className="page-error">
                        <h2>{strings.no_ravens_please_connect_your_ravens}</h2>
                        <hr />
                        <p>{strings.no_ravens_your_ravens_are_not_currently_detected}</p>
                        <p>{strings.no_ravens_your_ravens_are_not_currently_detected_instructions}</p>
                    </div>
                );
            } else {
                return (
                    <div className="page-error">
                        <h2>{strings.billing_info_required_title}</h2>
                        <hr />
                        <p>{strings.billing_info_required_description}</p>
                        <p><NavLink to={'/' + getCurrentLocale() + '/account/profile#billing'}>{strings.billing_click_here_to_open_billing_details}</NavLink> {strings.billing_then_click_the_edit_payment_information_button}</p>
                    </div>
                );
            }
        } else {
            return (
                <div className="page-error">
                    <h2>{strings.formatString(strings.no_ravens_title)}</h2>
                    <hr />
                    <p>{strings.formatString(strings.no_ravens_m1)}</p>
                    <p>{strings.formatString(strings.no_ravens_m2)}</p>
                    <p>{strings.formatString(strings.no_ravens_m3)}</p>
                </div>
            )
        }
    }
}
